import { put, call, all, takeEvery, take, delay } from "redux-saga/effects";
import getAuditlogsActions from "./action";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";

const AuditlogsSagas = function* () {
  yield all([yield takeEvery(getAuditlogsActions.GET_AUDITLOGS, Getauditlogs)]);
};

export function* Getauditlogs(data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  const result = yield call(() =>
    axios.post(
      `${API_URL}/backoffice/auditlogs/${payload?.Value}/${payload?.input}`
    )
  );
  if (result?.data?.statusCode === 200) {
    yield put({
      type: getAuditlogsActions.SET_AUDITLOGS,
      payload: result?.data?.data,
    });
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  }
  if (result?.data?.statusCode === 400) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 400 ? "failed" : "success",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

}

export default AuditlogsSagas;
